import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'

export const timelineEventDomId = (id: UUID) => `timeline-event-dom-id-${id}`

export const actionEventDomId = (id: UUID) => `action-event-dom-id-${id}`
